import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import qs from 'qs';

import Loader from '../../../components/Loaders/Loader';
import FilterGroup from '../../../components/Filters/FilterGroup';
import BonusesTable from './components/Table';
import ModalsManager from './components/Modals/Manager';

import { addBonus, editBonus, getBonusesList } from '../../../services/endpoints/settings';
import { settingsSelector } from '../../../redux/selectors/settings';

const Bonuses = () => {
  const location = useLocation();

  const selectedItem = useRef({});

  const queryString = qs.parse(location.search.slice(1));

  const reports = useSelector((state) => settingsSelector(state));
  const { mainConfig: config } = reports;
  const { access } = config;

  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState('');
  const [modalError, setModalError] = useState('');
  const [isLoading, setIsLoading] = useState({
    page: true,
    submit: false,
    modal: false,
    modalSubmit: false,
  });

  const onHideModals = () => {
    setOpenModal('');
    setIsLoading((prevState) => ({ ...prevState, modal: false, modalSubmit: false }));
    setTimeout(() => {
      selectedItem.current = {};
      setModalError('');
    }, 150);
  };

  const fetchList = async (loader = true) => {
    loader && setIsLoading((prevState) => ({ ...prevState, page: true }));
    try {
      const response = await getBonusesList(queryString);
      if (response.success) {
        setData(response.data);
      }
      loader && setIsLoading((prevState) => ({ ...prevState, page: false }));
    } catch (error) {
      loader && setIsLoading((prevState) => ({ ...prevState, page: false }));
    }
  };

  const onEdit = (item) => {
    selectedItem.current = item;
    setOpenModal('edit');
  };

  const onSendAdd = async (payload) => {
    setIsLoading((prevState) => ({ ...prevState, modalSubmit: true }));
    try {
      await addBonus(payload);
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
      onHideModals();
      fetchList();
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
      setModalError(error?.data?.error_message ?? 'Something went wrong');
    }
  };

  const onSendEdit = async (data) => {
    setIsLoading((prevState) => ({ ...prevState, modalSubmit: true }));
    try {
      await editBonus(selectedItem.current?.id, data);
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
      onHideModals();
      fetchList();
    } catch (error) {
      setModalError(error?.data?.error_message ?? 'Something went wrong');
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
    }
  };

  const onSubmitModal = (type, data) => {
    switch (type) {
    case 'add':
      onSendAdd(data);
      break;

    case 'edit':
      onSendEdit(data);
      break;

    default:
      break;
    }
  };

  useEffect(() => {
    fetchList();
    document.title = 'Bonuses';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="settings-bonuses">
      <ModalsManager
        open={openModal}
        error={modalError}
        item={selectedItem.current}
        isLoading={isLoading.modal}
        isLoadingSubmit={isLoading.modalSubmit}
        methods={data?.payment_methods}
        onHide={onHideModals}
        onSubmit={onSubmitModal}
      />

      {isLoading.page ? (
        <div className="loader-container" style={{ minHeight: '300px' }}>
          <Loader />
        </div>
      ) : (
        <>
          <FilterGroup>
            {access?.bonuses_add ? (
              <Button onClick={() => setOpenModal('add')} className="pull-left add-btn">
                Add bonus
              </Button>
            ) : null}
          </FilterGroup>

          {access?.bonuses_list ? <BonusesTable access={access} items={data?.bonuses} onEdit={onEdit} /> : false}
        </>
      )}
    </div>
  );
};

export default Bonuses;
